import { TITLE_CREATE_TEST_NEW, TITLE_CREATE_TEST_EDIT } from './constants';
import { TitleCreateTestType } from './types';

export const setTitleNew = (data: TitleCreateTestType) => (dispatch: any) => {
  dispatch({ type: TITLE_CREATE_TEST_NEW, payload: data });
};

export const setTitleEdit = (data: TitleCreateTestType) => (dispatch: any) => {
  dispatch({ type: TITLE_CREATE_TEST_EDIT, payload: data });
};
